import React, {Component} from 'react';
import { connect } from 'react-redux';
import * as antragActions from '../actions/antragActions';
import {bindActionCreators} from 'redux';
import { Steps, Button, Icon } from 'antd';
import FormGrundEig  from '../components/FormGrundEig';
import FormGrundAnzusch from '../components/FormGrundAnzusch';
import FormInstallateur  from '../components/FormInstallateur';
import FormSonstiges from '../components/FormSonstiges';
import {reset, destroy, initialize, Field} from 'redux-form';
import * as validate from "../components/FormValidation";


const Step = Steps.Step;

/*
const FormGrundEigINIT = {
    req.body.Grund_Name,
    req.body.Grund_Vorname,
    req.body.Grund_Firma,
    req.body.Grund_Strasse,
    req.body.Grund_PLZ,
    req.body.Grund_Ort,
    req.body.Grund_Tel_Priv,
    req.body.Grund_Tel_Arbeit,
    req.body.Grund_Mail,
    req.body.Grund_Fax,
    req.body.Grund_Tel_Mobil,
    req.body.Ans_Strasse,
    req.body.Ans_PLZ,
    req.body.Ans_Ort,
    req.body.Ans_Bez_Baugeb,
    req.body.Ans_Gemarkung,
    req.body.Ans_Grund_Groesse,
    req.body.Ans_Fl_Nr,
    req.body.Ans_Baubeginn,
    req.body.Ans_Wohnhaus,
    req.body.Ans_Garage,
    req.body.Ans_Stall,
    req.body.Ans_Sonstiges,
    req.body.Ans_Beantr_Wassermenge,
    req.body.Ans_Vermessen,
    req.body.Ans_Regenwasser,
    req.body.Ans_Abgebrochen,
    req.body.Ans_Abbruchtermin,
    req.body.Inst_Installateur,
    req.body.Inst_Mail,
    req.body.Inst_Verzeichnis,
    req.body.Inst_Ausweis_Nr,
    req.body.Sonst_Angaben,
    req.body.Bemerkung
};
*/

const thisForm = [
    {
        type: 'Textbox',
        label: 'Installateur:',
        set: 'Inst_Installateur',
        required: false
    },
    {
        type: 'Textbox',
        label: 'E-Mail:',
        set: 'Inst_Mail',
        required: false
    },
    {
        type: 'Textbox',
        label: 'Eingetragen im Installateurverzeichnis von:',
        set: 'Inst_Verzeichnis',
        required: false
    },
    {
        type: 'Textbox',
        label: 'Ausweis Nr.:',
        set: 'Inst_Ausweis_Nr',
        required: false
    }
];

class Auftrag extends Component {


    componentDidMount() {
        //this.props.dispatch(reset('auftragform'));
       // window.setTimeout(() => {this.props.dispatch(initialize('auftragform')); }, 2000);

    }

    componentWillUnmount() {
        //this.props.actions.reset();
        this.props.dispatch(destroy('auftragform'));
    }

    nextPage() {
        this.props.actions.changeStep(this.props.step+1);
        window.scrollTo(0, 0);
    }

    previousPage() {
        this.props.actions.changeStep(this.props.step-1);
        window.scrollTo(0, 0);
    }

    submit(values) {
        this.props.actions.saveAntrag(values);
    }




        render() {


            return (
               <div className={"container"}>
                   <div className={"content"}>

                       <Steps progressDot current={this.props.step}>
                           <Step title="&nbsp;" description="Grundstückseigentümer / -in" />
                           <Step title="&nbsp;" description="Anzuschl. Grundstück" />
                           <Step title="&nbsp;" description="Ausführender Installateur"/>
                           <Step title="&nbsp;" description="Sonstige Angaben"/>
                       </Steps>



                           {this.props.step === 0 && <FormGrundEig onSubmit={() => this.nextPage()} back={() => this.previousPage()} />}
                           {this.props.step === 1 && <FormGrundAnzusch onSubmit={() => this.nextPage()} back={() => this.previousPage()} />}
                           {this.props.step === 2 && <FormInstallateur onSubmit={() => this.nextPage()} back={() => this.previousPage()} />}
                           {this.props.step === 3 && <FormSonstiges onSubmit={(values) => this.submit(values)} saving={this.props.saving} back={() => this.previousPage()} />}




                       {/*<Button type={"primary"} htmlType={"button"} onClick={() => this.props.actions.changeStep(this.props.step-1) } ><Icon type={"left"}/> Zurück</Button>
                       <Button type={"primary"} htmlType={"button"} onClick={() => this.props.actions.changeStep(this.props.step+1) } >Weiter <Icon type={"right"}/></Button>
                       */}
               </div>
           </div>
        );
    }
};


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(antragActions, dispatch),
        dispatch: dispatch
    };
}

function mapStateToProps(state) {

    const { antragReducer } = state;
    const { step, saving } = antragReducer;

    return {
        step,
        saving
    }
}


export default connect(mapStateToProps,mapDispatchToProps, null, {pure: false })(Auftrag)





// WEBPACK FOOTER //
// ./src/containers/auftrag.js